import { makeAutoObservable, runInAction } from "mobx";
import homeService from "./homeService";
import { StoreLocation } from "../../../types/common";

/* eslint-disable @typescript-eslint/no-explicit-any */
class HomeStore {
    popularNow: any[] = [];
    popularCategories: any[] = [];
    newProducts: any[] = [];
    storeLocations: StoreLocation[] = [];

    count: number = 0;

    constructor() {
        makeAutoObservable(this)
    }


    fetchPopularNow = async () => {
        const response = await homeService.fetchPopularNow();
        console.log(response);
        
        runInAction(() => {
            this.popularNow = response;
        });
    }

    setCount = (count: number) => {
        runInAction(() => {
            this.count = count;
        })
    } 

    fetchStoreLocation = async () => {
        const response = await homeService.fetchStoreLocation()

        runInAction(() => {
            this.storeLocations = response;
        });
    }
}

export default new HomeStore();